import { FieldValues, useForm } from 'react-hook-form';
import { TextField } from '@mui/material';
import React from 'react';
import { getError, hasError, labelIsOnTop } from '../helpers';
import { CustomFieldFormLabel } from '../CustomFieldFormLabel';
import { CustomFieldRenderComponentProps } from '../types';

interface CustomFieldTextProps extends CustomFieldRenderComponentProps {
  value: FieldValues;
}

export const CustomFieldText: React.FC<CustomFieldTextProps> = ({
  field,
  disabled,
  value,
  onChange,
}) => {
  const { errors } = useForm();

  return (
    <>
      <CustomFieldFormLabel field={field} checkLabelOnTop />
      <TextField
        disabled={disabled}
        value={value || ''}
        onChange={onChange}
        fullWidth
        placeholder={field.placeholder || undefined}
        error={hasError(errors, field)}
        label={(labelIsOnTop(field) ? field.placeholder : field.name) || undefined}
        helperText={getError(errors, field) || ' '}
      />
    </>
  );
};
